module.exports = __webpack_public_path__ + "img/following-up.7f6588f8.png";